import getExtendedPropertyValue from './getExtendedPropertyValue';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
var NORMALIZED_SUBJECT_PROPERTY_TAG = '0xe1d';
export default function getReplyForwardSubject(item, isReply) {
    var normalizedSubject = getExtendedPropertyValue(item, NORMALIZED_SUBJECT_PROPERTY_TAG) ||
        item.Subject ||
        '';
    var prefix = (isReply ? strings.replySubjectPrefix : strings.forwardSubjectPrefix).trim();
    return format('{0} {1}', prefix, normalizedSubject);
}
//# sourceMappingURL=getReplyForwardSubject.js.map